module.exports = __webpack_public_path__ + "static/media/home.7a8547f9.svg";